import { Injectable} from '@angular/core';
import { ContractStepModel, ContractWrapperModel } from '../../../models/contract.model';
import { Subject } from 'rxjs';
import { AlertService } from '../../../services/notify/alert.service';
import { ContractStatusToRunAutoReload, ContractStatusToRunAutoReloadOneSigner, IContractDataModel } from '../models/contract-internal-models';
import { ContractDataService } from './contract-data.service';
const REFRESH_INTERVAL = 3000
interface IReloadData {
  contract:{
    guid:string
    status_at:string,
    updated_at:string,
    verified_at:string
  },
  roadmap:{
    guid:string,
    updated_at:string
  },
  autoReloadInterval:ReturnType<typeof setInterval>|undefined
}
@Injectable({
    providedIn: 'root'
})
export class ContractAutoUpdateService {
  private autoReloadData:Map<string,IReloadData> = new Map()
  public subReloadedIsNeeeded: Subject<{contracGuid:string}> = new Subject()
  constructor(
    private contractDataService:ContractDataService,
    private alertService:AlertService,
  ) { }
    public setAutoReloadInterval(contractData:IContractDataModel|null, setNewInterval:boolean=true) {
      let reloadInteval = this.autoReloadData.get(contractData?.contract?.contract.guid||'null')?.autoReloadInterval
      reloadInteval && contractData?.contract? this.resetAutoReloadInterval(contractData.contract,reloadInteval) : null;

      let usersSignedContractLen = contractData?.allSignatoriesInContract.filter(x => x.verified_at).length||0
      let statusContractCondition = ContractStatusToRunAutoReload.includes(contractData?.contract?.contract.status||'null')
      let atLeastOneUserSignedContractCondition = ContractStatusToRunAutoReloadOneSigner.includes(contractData?.contract?.contract.status||'null') && usersSignedContractLen>0
      
      if (setNewInterval && (statusContractCondition ||atLeastOneUserSignedContractCondition) )  {
        contractData?.contract? this.runAutoReloadInterval(contractData) : null;
      } 
    }
    private addUpdateReloadData(contractData:ContractWrapperModel, reloadInteval?:ReturnType<typeof setInterval>):IReloadData {
      let newReloadData = {
        contract: {
          guid:contractData.contract.guid,
          updated_at:contractData.contract.updated_at,
          status_at:contractData.contract.status_at,
          verified_at:contractData.contract.verified_at
        },
        roadmap:{
          updated_at:contractData.roadmap_active.updated_at,
          guid:contractData.roadmap_active.guid,
        },
        autoReloadInterval:reloadInteval
      }
      this.autoReloadData.set(contractData.contract.guid,newReloadData)
      return newReloadData
    }
    private resetAutoReloadInterval(contractData:ContractWrapperModel, reloadInteval:ReturnType<typeof setInterval>) {
      
      clearInterval(reloadInteval)
      this.addUpdateReloadData(contractData)
    }
    private runAutoReloadInterval(contractData:IContractDataModel) {
      if (!contractData.contract) {
        return
      }
      
      let contractGuid = contractData.contract.contract.guid
      let reloadData = this.autoReloadData.get(contractData.contract?.contract.guid||'null')
      reloadData = reloadData||this.addUpdateReloadData(contractData.contract);
      reloadData.autoReloadInterval = setInterval(() =>
        this.contractDataService.getContractByGuid(contractGuid).subscribe(data => {
          console.log('NEW INTERVAL',reloadData.autoReloadInterval )
          // добавлен ли новый обьект к шагу в статусе контракта verified
          let currentRoadMap = contractData.contractRoadmapCopyBeforeEdit?.steps
          currentRoadMap && data.roadmap_active.steps?.every((newStep,index)=>{
            let currentStep = currentRoadMap[index]
            currentStep.target_key !== newStep.target_key? this.newTargetAddedVSHandler(contractGuid,currentStep) :null
            return currentStep.target_key === newStep.target_key
          })
          // добавлен ли новый обьект к шагу в статусе контракта verified
          currentRoadMap && data.roadmap_active.steps?.every((newStep,index)=>{
            let currentStep = structuredClone(currentRoadMap[index])
            delete currentStep.auto_name
            delete currentStep.tagData
            delete currentStep.membersAvatarsToShow
            new Promise<boolean>((resolve) => {
              resolve (JSON.stringify(currentStep) === JSON.stringify(newStep))
            }).then(stepsAreIdentical=>{
              if (stepsAreIdentical===false) {
                console.log('JSON.stringify diff',currentStep.auto_name||currentStep.name)
                
                //this.stepsAreDifferentHandler(contractGuid,currentStep)
                //console.log('currentStep',currentStep||'null' )
                //console.log('newStep',newStep )
                return stepsAreIdentical
              }
            })
          })

          // изменилась ли дорожная карта после подписания одним из участников
          if (reloadData.roadmap.updated_at !== data.roadmap_active.updated_at ) {
            this.roadMapChagnedHandler(contractGuid)
          }

          // все участики подписали контракт
          if (reloadData.contract.verified_at !== data.contract.verified_at && data.contract.status === 'verified') {
            this.contactVerifiedHandler(contractGuid)
          }

        }), REFRESH_INTERVAL);
    }
    private roadMapChagnedHandler(contractGuid:string){
      this.alertService.setAlert('Дорожная карта изменилась','red',5)
      this.alertService.setAlert('Контракт требуется подписать заново','red',5)
      this.alertService.setAlert('Запускаем автообновление','nd_color')
      this.subReloadedIsNeeeded.next({contracGuid:contractGuid})
    }
    private contactVerifiedHandler(contractGuid:string){
      this.alertService.setAlert('Контракт успешно подписан всеми участниками','nd_color',5)
      this.alertService.setAlert('Запускаем автообновление','nd_color')
      this.subReloadedIsNeeeded.next({contracGuid:contractGuid})
    }
    private newTargetAddedVSHandler(contractGuid:string, step:ContractStepModel){
      this.alertService.setAlert('Добавлен объект к этапу '+ step.sort_index +'.'+ (step.auto_name||step.name),'red',5)
      this.alertService.setAlert('Запускаем автообновление','nd_color')
      this.subReloadedIsNeeeded.next({contracGuid:contractGuid})
    }
    private stepsAreDifferentHandler(contractGuid:string, step:ContractStepModel){
      this.alertService.setAlert('Состояние этапа изменилось.Этап: '+ step.sort_index +'.'+ (step.auto_name||step.name),'red',5)
      this.alertService.setAlert('Запускаем автообновление','nd_color')
      this.subReloadedIsNeeeded.next({contracGuid:contractGuid})
    }
}